import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Typography,
  Autocomplete,
  Avatar,
  Menu,
  Card,
  CardMedia,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseLandingsPages } from "./UseLandingsPages";
import { useSnackbar } from "notistack";
import ClusterAutoComplete from "../../basic-information/productCluster/ClusterAutoComplete";
import { UseProductCluster } from "../../basic-information/productCluster/UseProductCluster";
import { SketchPicker } from "react-color";
import { FileUploader } from "react-drag-drop-files";
import DeleteIcon from "@mui/icons-material/Delete";
import LandingImagesGrid from "./LandingImagesGrid";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditLandingPage() {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const { enqueueSnackbar } = useSnackbar();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetLandingPageByID, UpdateLandingPage } = UseLandingsPages();
  const navigate = useNavigate();
  const location = useLocation();
  const { getResultByID } = UseProductCluster();
  const { validate } = UseLandingsPages();
  const [stateclusterID, setStateclusterID] = useState({
    clusterID: undefined,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
    description: undefined,
    metaDescription: undefined,
    pageType: undefined,
    searchURL: undefined,
    backgroundColor: undefined,
    productCardType: undefined,
    descriptionType: false,
  });
  const { isSmall } = useBreakpoints();
  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
    pageType: false,
  });

  const cardType = [
    { id: 1, type: "1" },
    { id: 2, type: "2" },
  ];

  const pageType = [
    { id: 1, type: "صفحه لندینگ" },
    { id: 2, type: "صفحه جستجو" },
    { id: 3, type: "صفحه اختصاصی" },
  ];

  const [imgState, setImgState] = useState({
    file: undefined,
    url: "",
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      GetLandingPageByID(location.state.id, (callback) => {
        setImgState({
          file: undefined,
          url: callback.backgroundImage,
        });
        setState({
          id: callback.id,
          faName: callback.faName,
          enName: callback.enName,
          description: callback.description,
          metaDescription: callback.metaDescription,
          pageType: callback.pageType,
          searchURL: callback.searchURL,
          backgroundColor: callback.backgroundColor,
          productCardType: callback.productCardType,
          descriptionType: callback.descriptionType,
        });
      });
    }
  }, [location.state]);

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, searchURL: "/landingmanagment" },
          {
            name: "ویرایش صفحه لندینگ",
            searchURL: "/landingmanagment/editLandinPage",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span  3"}>
          <Autocomplete
            size="small"
            value={state.pageType ? state.pageType : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                setState({ ...state, pageType: newValue });
              } else {
                setState({ ...state, pageType: undefined });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return pageType?.find((m) => m.id == option).type;
              }
              return "";
            }}
            fullWidth
            options={pageType.map((m) => m.id)}
            renderInput={(params) => (
              <TextField
                error={errorState.pageType}
                variant="outlined"
                {...params}
                label="نوع صفحه"
              />
            )}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span  4"}>
          <TextField
            fullWidth
            value={state.faName ? state.faName : ""}
            error={errorState.faName}
            label="نام فارسی"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, faName: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span  4"}>
          <TextField
            fullWidth
            id="outlined-basic"
            value={state.enName ? state.enName : ""}
            error={errorState.enName}
            sx={{
              input: { direction: "rtl" },
            }}
            label="نام لاتین"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, enName: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 4 }}
          gridColumn={isSmall ? "span 12" : "span  4"}
        >
          <ClusterAutoComplete
            width100
            selectedClusterID={stateclusterID.clusterID}
            setter={setStateclusterID}
            lvl1State={stateclusterID}
            disabled={!state.pageType || state.pageType == 1 ? true : false}
          />
          <Button
            disabled={!state.pageType || state.pageType == 1 ? true : false}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (!stateclusterID.clusterID) {
                enqueueSnackbar("لطفا خوشه را انتخاب کنید", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
              setProgress(true);
              getResultByID(stateclusterID.clusterID, (callback) => {
                setState({ ...state, searchURL: callback });
              });
            }}
          >
            ایجاد
          </Button>
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span  6"}>
          <TextField
            disabled={!state.pageType || state.pageType == 1 ? true : false}
            fullWidth
            value={state.searchURL ? state.searchURL : ""}
            sx={{
              textarea: { direction: "rtl" },
            }}
            multiline
            rows={2}
            label="آدرس صفحه جستجو"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, searchURL: evt.target.value });
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span  3"}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography color="secondary" variant="body1">
              رنگ پس زمینه:
            </Typography>
            <Avatar
              sx={{
                bgcolor: state.backgroundColor,
                boxShadow: 3,
                width: 35,
                height: 35,
                mx: 1,
              }}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              {" "}
            </Avatar>
            <Typography variant="body1">
              {state.backgroundColor ? state.backgroundColor : ""}
            </Typography>
            {state.backgroundColor ? (
              <Button
                sx={{ ml: 2 }}
                variant="outlined"
                onClick={(color) => {
                  setState({ ...state, backgroundColor: "" });
                }}
              >
                حذف
              </Button>
            ) : (
              ""
            )}
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
            sx={{
              "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
                py: 0,
              },
            }}
          >
            <SketchPicker
              sx={{ position: "relative", top: "-130px" }}
              color={state.backgroundColor ? state.backgroundColor : ""}
              onChangeComplete={(color) => {
                setState({ ...state, backgroundColor: color.hex });
              }}
            />
          </Menu>
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: "flex-start",
            gap: 2,
          }}
          gridColumn="span 12"
        >
          <Typography sx={{ mb: 1 }} color="secondary" variant="body1">
            تصویر پس زمینه:
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box>
                  <Card
                    sx={{
                      width: "200px",
                      height: "auto",
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url ? imgState.url : "/static/img/nobanner.jpg"
                      }
                    />
                  </Card>
                </Box>
              }
            />
            <IconButton
              onClick={() => {
                setState({ ...state, backgroundImage: "" });
                setImgState({
                  file: undefined,
                  url: undefined,
                });
              }}
              sx={{
                display: "flex",
                bgcolor: "#dec2ff",
                visibility: imgState.url ? "visible" : "hidden",
              }}
            >
              <DeleteIcon sx={{ color: "secondary.main" }} />
            </IconButton>
          </Box>
        </Box>
        <Box gridColumn={isSmall ? "span 8" : "span  2"}>
          <Autocomplete
            size="small"
            value={state.productCardType ? state.productCardType : ""}
            onChange={(event, newValue) => {
              if (newValue) {
                setState({ ...state, productCardType: newValue });
              } else {
                setState({ ...state, productCardType: undefined });
              }
            }}
            isOptionEqualToValue={(option, value) => {
              return value == "" || option === value;
            }}
            getOptionLabel={(option) => {
              if (option) {
                return cardType?.find((m) => m.id == option).type;
              }
              return "";
            }}
            fullWidth
            options={cardType.map((m) => m.id)}
            renderInput={(params) => (
              <TextField
                variant="outlined"
                {...params}
                label="نوع کارت محصول"
              />
            )}
          />
        </Box>
        <Box gridColumn="span 10"></Box>
        <Box gridColumn="span 12">
          <Typography color="secondary" variant="subtitle1">
            توضیحات :{" "}
          </Typography>
          <Box>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (searchURL) =>
                        /^(https?:)?\/\//.test(searchURL),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              data={state.description ? state.description : ""}
              onChange={(event, editor) => {
                const data = editor.getData();
                if (state.id) {
                  setState({ ...state, description: data });
                }
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "300px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
        </Box>
        <Box gridColumn="span 12">
          <FormControlLabel
            checked={state.descriptionType ? state.descriptionType : false}
            onChange={(evt) => {
              setState({ ...state, descriptionType: evt.target.checked });
            }}
            control={<Checkbox sx={{ py: 0 }} />}
            label="به صورت پیش فرض توضیحات کامل نمایش داده شود"
          />
        </Box>
        <Box gridColumn="span 12">
          <Typography color="secondary" variant="subtitle1">
            توضیحات متا :{" "}
          </Typography>
          <TextField
            fullWidth
            value={state.metaDescription ? state.metaDescription : ""}
            multiline
            maxRows={5}
            onChange={(evt) => {
              if (
                evt.target.value.length < 151 ||
                evt.target.value.length < state.metaDescription.length
              ) {
                setState({ ...state, metaDescription: evt.target.value });
                return;
              } else {
                setState({
                  ...state,
                  metaDescription: state.metaDescription,
                });
                enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                  variant: "error",
                  autoHideDuration: 2000,
                  preventDuplicate: true,
                });
                return;
              }
            }}
            size="small"
            variant="outlined"
          />
        </Box>
        <Box gridColumn="span 12">
          <Typography color="secondary" variant="subtitle1">
            تصاویر لندینگ :{" "}
          </Typography>
          <LandingImagesGrid landingID={state.id} />
        </Box>

        <Box
          gridColumn="span 12"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                if (state.pageType && state.pageType == 2 && !state.searchURL) {
                  enqueueSnackbar("لطفا آدرس صفحه جستجو را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                setProgress(true);
                UpdateLandingPage(state, imgState.file, () => {
                  setMsGotoLast(true);
                  navigate("/landingmanagment", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/landingmanagment", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
